import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./DesactiveModal.scss";

interface CancelContinueProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  icon: IconDefinition;
  iconColor: string;
}

const CancelContinue: React.FC<CancelContinueProps> = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  icon,
  iconColor,
}) => {
  const [isEnabled, setIsEnabled] = useState(true);
  useEffect(() => {
    setIsEnabled(true);
  }, [show]);
  return (
    <Modal show={show} onHide={onHide} centered className="desactive-modal">
      <Modal.Header className="d-flex justify-content-between align-items-center">
        <Modal.Title>{title}</Modal.Title>
        <Button variant="link" onClick={onHide} className="close-button">
          <FontAwesomeIcon icon={faTimes} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center" style={{ whiteSpace: "pre-wrap" }}>
          {message}
        </p>
        <div className="text-center">
          <FontAwesomeIcon icon={icon} className={`${iconColor} fa-3x`} />
        </div>
      </Modal.Body>
      <Modal.Footer
        className="justify-content-between"
        style={{ margin: "-1rem 3rem" }}
      >
        <Button variant="secondary" onClick={onHide}>
          Cancelar
        </Button>
        <Button
          variant="primary"
          disabled={!isEnabled}
          onClick={() => {
            setIsEnabled(false);
            onConfirm();
          }}
        >
          Confirmar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelContinue;
